"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cell = exports.cellFocusMixin = exports.CELL = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var theme_get_1 = require("@styled-system/theme-get");
var Box_1 = require("../Box");
exports.CELL = {
    alignItems: "center",
    backgroundColor: "background",
    borderColor: "border",
    borderStyle: "solid",
    borderWidth: "1px",
    color: "primary",
    display: "flex",
    fontFamily: "body",
    fontSize: [2, 2, 3],
    lineHeight: 2,
    px: 6,
    py: 4,
    transition: "box-shadow 250ms ease",
};
exports.cellFocusMixin = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  outline: 0;\n  box-shadow: inset 0 0 0 ", " ", ";\n"], ["\n  outline: 0;\n  box-shadow: inset 0 0 0 ", " ", ";\n"])), (0, theme_get_1.themeGet)("space.1"), (0, theme_get_1.themeGet)("colors.accent"));
exports.Cell = (0, styled_components_1.default)(Box_1.Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:focus {\n    ", "\n  }\n"], ["\n  &:focus {\n    ", "\n  }\n"])), exports.cellFocusMixin);
exports.Cell.defaultProps = __assign({}, exports.CELL);
exports.Cell.displayName = "Cell";
var templateObject_1, templateObject_2;
//# sourceMappingURL=Cell.js.map